import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">
         <span className="section-number"></span>Request a Consultation</h2>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-visual">
              <svg viewBox="0 0 400 300" className="contact-illustration">
                <defs>
                  <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor: '#64FFDA', stopOpacity: 1}} />
                    <stop offset="100%" style={{stopColor: '#667EEA', stopOpacity: 1}} />
                  </linearGradient>
                </defs>
                
                {/* Envelope */}
                <rect x="50" y="80" width="300" height="180" rx="10" fill="var(--secondary-bg)" stroke="url(#grad4)" strokeWidth="3"/>
                <path d="M50 80 L200 180 L350 80" stroke="url(#grad4)" strokeWidth="3" fill="none" strokeLinejoin="round"/>
                <path d="M50 260 L150 180 M350 260 L250 180" stroke="url(#grad4)" strokeWidth="3"/>
                
                {/* Floating icons */}
                <g className="float-icon">
                  <circle cx="80" cy="50" r="20" fill="rgba(100, 255, 218, 0.2)" stroke="url(#grad4)" strokeWidth="2"/>
                  <text x="80" y="58" textAnchor="middle" fontSize="20">@</text>
                </g>
                
                <g className="float-icon" style={{animationDelay: '0.5s'}}>
                  <circle cx="320" cy="50" r="20" fill="rgba(100, 255, 218, 0.2)" stroke="url(#grad4)" strokeWidth="2"/>
                  <path d="M310 50 L315 45 L330 50 L315 55 Z" fill="currentColor"/>
                </g>
              </svg>
            </div>
            
            <div className="contact-text">
              <h3>Consulting & Advisory Engagements</h3>
              <p>
              Providing cloud, DevOps, reliability, and IT advisory services
              to startups and SMEs, supporting informed technical decision-making
              as organizations scale.
              </p>
              
              <p>
              For organizations exploring improvements to infrastructure,
              platform reliability, or overall technology direction, an
              introductory 15-minute consultation is available to assess
              requirements and outline next steps.
              </p>
            </div>
          </div>
          
          <div className="contact-methods">
            <a href="mailto:me@shahd.me" className="contact-card">
              <div className="contact-card-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M2 7 L12 13 L22 7" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Email</h4>
              <p>Professional inquiries</p>
            </a>
            
            <a href="https://linkedin.com/in/shahdabubaker" target="_blank" rel="noopener noreferrer" className="contact-card">
              <div className="contact-card-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M8 11v5M8 8v.5M12 16v-4a2 2 0 0 1 4 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4>LinkedIn</h4>
              <p>Connect with me</p>
            </a>

            <a href="https://wa.me/962780000270?text=Hello,%20I%20would%20like%20to%20request%20a%2015-minute%20introductory%20consultation%20regarding%20cloud,%20DevOps,%20or%20IT%20advisory."
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card"
               >
              <div className="contact-card-icon">
                {/* WhatsApp logo SVG */}
                <svg viewBox="0 0 32 32" fill="currentColor">
                  <path d="M16 3C9.372 3 4 8.372 4 15c0 2.43.792 4.687 2.126 6.527L5 28l6.646-1.742A11.91 11.91 0 0016 27c6.628 0 12-5.372 12-12S22.628 3 16 3zm0 22a9.9 9.9 0 01-5.09-1.393l-.365-.216-3.942 1.034 1.05-3.839-.238-.372A9.87 9.87 0 016 15c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10zm5.275-7.646c-.287-.144-1.7-.836-1.963-.931-.263-.096-.454-.144-.646.144-.191.287-.74.93-.908 1.122-.167.191-.335.215-.622.072-.287-.144-1.214-.447-2.31-1.424-.854-.761-1.43-1.7-1.598-1.987-.167-.287-.018-.443.126-.587.13-.13.287-.335.43-.503.144-.167.191-.287.287-.478.096-.191.048-.359-.024-.503-.072-.144-.646-1.558-.885-2.134-.233-.56-.472-.484-.646-.492l-.552-.01c-.191 0-.503.072-.767.359-.263.287-1.003.98-1.003 2.392 0 1.412 1.028 2.773 1.171 2.96.144.191 2.022 3.087 4.9 4.326.685.296 1.219.472 1.636.604.687.219 1.311.188 1.805.114.551-.082 1.7-.694 1.941-1.364.239-.67.239-1.245.167-1.364-.072-.12-.263-.191-.55-.335z" />
                </svg>
              </div>
              <h4>WhatsApp</h4>
              <p>Book a consultation</p>
            </a>
            
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

